export const selectFamilies = state => state.families;
